import React, { useContext, useEffect } from 'react';
import Bar from '../layout/Bar';
import Sidebar from '../layout/Sidebar'
import FormTasks from '../tasks/FormTasks';
import TaskList from '../tasks/TaskList';
import AuthContext  from '../../context/auth/authContext';

const Projects = () => {

    // Extract information of authentication
    const authContext = useContext(AuthContext);
    const { authenticatedUser } = authContext;

    useEffect(() => {
        authenticatedUser();
        //eslint-disable-next-line
    }, []);

    return ( 
        <div className="contenedor-app">
            <Sidebar />
            <div className="seccion-principal">
                <Bar />
                <main>
                    <FormTasks />
                    <div className="contenedor-tareas">
                        <TaskList />
                    </div>
                </main>
            </div>
        </div>
     );
}
 
export default Projects;